import { useState } from 'react'

import { EMPTY_OBJECT } from '../../constants/common'

export function useElementFocusState({ onBlur, onFocus } = EMPTY_OBJECT) {
  const [focused, setFocused] = useState(false)

  function handleFocus(event) {
    setFocused(true)

    onFocus?.(event)
  }

  function handleBlur(event) {
    setFocused(false)

    onBlur?.(event)
  }

  return {
    focused,
    handleBlur,
    handleFocus,
  }
}
